import { NBN_PERSISTENT_EXPIRE_SPAN } from '@belong/constants';
import { logger } from '@belong/logging';
import { IErrorResponse } from '@belong/types';
import { JOIN_JOURNEY_TYPE } from './consts';
import type { AnalyticsEvents } from '../index';

interface IResumptionAnalyticsParams extends Record<string, any> {
  expireDate?: string;
  previousAttemptNumber?: number;
  resumeFromLastStep: string;
  resumeType: string;
  journeyResumptionError?: IErrorResponse;
}

const getSessionGap = (expireDate?: string): number | undefined => {
  if (!expireDate) {
    return undefined;
  }

  const parsedExpireDate = new Date(expireDate);
  const expireDateTimestamp = parsedExpireDate.getTime();

  if (Number.isNaN(expireDateTimestamp)) {
    logger.error('Invalid expireDate format in persisted data', { expireDate });

    return undefined;
  }

  const persistedTimestamp = expireDateTimestamp - NBN_PERSISTENT_EXPIRE_SPAN;

  // Return value in seconds
  return Math.floor((Date.now() - persistedTimestamp) / 1000);
};

const getResumeAttemptNumber = (previousAttemptNumber: number = 0): number => {
  return previousAttemptNumber + 1;
};

export const sendResumptionEvent = (
  analyticsEvents: AnalyticsEvents,
  {
    expireDate,
    previousAttemptNumber,
    resumeFromLastStep,
    resumeType,
    journeyResumptionError,
    ...otherProps
  }: IResumptionAnalyticsParams
) => {
  const sessionGap = getSessionGap(expireDate);
  const attemptNumber = getResumeAttemptNumber(previousAttemptNumber);

  const resumeAnalytics = {
    status: JOIN_JOURNEY_TYPE.RESUMED,
    attemptNumber,
    mechanism: resumeType
  };

  analyticsEvents.send({
    ...otherProps,
    journeyResumption: {
      ...resumeAnalytics,
      sessionGap,
      resumeFromLastStep,
      error: journeyResumptionError
    }
  });

  return resumeAnalytics;
};
